module.exports = __webpack_public_path__ + "img/product-4.c7ae2863.jpg";